import { Col, Icon, Tappable, Text, useTheme } from "@rally/ui-kit";
import { useState } from "react";
import { say } from "../../localization/say.ts";
import { calledBy } from "../../me/called.ts";

type Somebody = { handle: string; displayName?: string | null };

export function Handed({
  by,
  text,
  known,
}: {
  by: string;
  text: string;
  known: Map<string, Somebody> | { get: (account: string) => Somebody | undefined };
}) {
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const from = known.get(by);
  const to = /^@([A-Za-z0-9-]+)/.exec(text)?.[1] ?? "";
  const task = text.replace(/^@[A-Za-z0-9-]+\s*/, "");
  const fromSaid = from ? (calledBy(from) ?? from.handle) : by;
  return (
    <Tappable
      onPress={() => setOpen((was) => !was)}
      accessibilityRole="button"
      accessibilityState={{ expanded: open }}
      testID="handed"
      style={{
        flexDirection: "row",
        alignItems: "flex-start",
        gap: theme.space[2],
        paddingVertical: theme.space[1],
        paddingHorizontal: theme.space[2],
      }}
    >
      <Icon name="corner-down-right" size={14} color="text.tertiary" style={{ marginTop: 2 }} />
      <Col style={{ flex: 1, minWidth: 0 }}>
        <Text typeName="caption" color="text.tertiary" numberOfLines={open ? undefined : 1}>
          {say("chat.handed")(fromSaid, to)}
          {task ? ` · ${task}` : ""}
        </Text>
      </Col>
    </Tappable>
  );
}
